import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { SessionStateService } from '../core/auth/session-state.service'

@Injectable()
export class ApiInterceptorsService implements HttpInterceptor {
    constructor(private session: SessionStateService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const langCurrent = localStorage.getItem('lang')
            ? localStorage.getItem('lang')
            : 'en'

        // Same in-memory value the 401 handler compares against
        const authStateVersion = this.session.getAuthStateVersion().toString()

        const headers: any = {
            Lang: `${langCurrent}`,
            Timezoneoffset: new Date().getTimezoneOffset().toString(),
            'X-Auth-State-Version': authStateVersion
        }

        // Extract CSRF token from cookie and add to header
        const csrfToken = this.getCookie('XSRF-TOKEN')
        if (csrfToken) {
            headers['X-XSRF-TOKEN'] = csrfToken
        }

        const reqClone = req.clone({
            setHeaders: headers,
            withCredentials: true
        })

        return next.handle(reqClone)
    }

    private getCookie(name: string): string | null {
        const nameEQ = name + '='
        const cookies = document.cookie.split(';')
        for (let cookie of cookies) {
            cookie = cookie.trim()
            if (cookie.indexOf(nameEQ) === 0) {
                const cookieValue = cookie.substring(nameEQ.length)
                // Decode URL-encoded cookie value
                return decodeURIComponent(cookieValue)
            }
        }
        return null
    }
}
